export default __webpack_public_path__ + "static/therapy3-d47c43a5ea9498456ce8064a695c049a.webp";